import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-input-server-filter-dropdown',
  templateUrl: './input-server-filter-dropdown.component.html',
  styleUrls: ['./input-server-filter-dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InputServerFilterDropdownComponent implements OnChanges {

  @Input()
  selectedItemInternal;
  @Input()
  title: string = '';
  @Input()
  items: any[];
  @Input()
  displayField: string = ''; //use this field when working with list of objects to specify field to show in multiple select
  @Input()
  placeholder = '';
  @Input()
  customStyle: any;
  @Input()
  hasError = false;
  @Input()
  disabled = false;
  @Input()
  asterix = false;

  @Output()
  selectedItem = new EventEmitter<any>();
  @Output()
  searchTerm = new EventEmitter<string>();


  ngOnChanges(changes: SimpleChanges) {
    if (changes.items)
      this.items = [...this.items];
  }

  selectedChanged($event: any) {
    this.selectedItem.emit($event);
  }

  onSearch($event: { term: string; items: any[] }) {
    this.searchTerm.emit($event.term);
  }

  customSearchFn(term: string, item: any) {
    return true; // disable default filtering
  }
}
